import { trackJourneyEvent } from "src/services/segment";
import { EVENT_TRACKING } from "src/consts/eventTracking";

/** Shared explore_organisation journey envelope defaults. */
export const EXPLORE_JOURNEY = {
  journey_macro: "explore_organisation",
  interaction_mode: "read",
  audience_tier: "general",
  feature_availability: true,
};

/**
 * Last emit key for Search Results Viewed. Key is `${mountScope}:${searchTerm}`
 * so parallel people/groups/tags/positions hooks share one emit, while
 * independent mounts (header typeahead vs search page) do not suppress each other.
 * @type {string | undefined}
 */
let lastSearchResultsViewedKey;

/**
 * @param {string} event
 * @param {Record<string, unknown>} [properties]
 */
export const trackExploreJourneyEvent = (event, properties = {}) => {
  trackJourneyEvent(event, {
    ...EXPLORE_JOURNEY,
    ...properties,
  });
};

/**
 * Emit Search Results Viewed once per mountScope + searchTerm.
 * @param {string} mountScope - stable id from the owning parallel/search mount
 * @param {unknown} searchTerm
 * @param {Record<string, unknown>} [properties]
 */
export const trackSearchResultsViewedOnce = (
  mountScope,
  searchTerm,
  properties = {}
) => {
  const key = `${mountScope}:${String(searchTerm ?? "")}`;
  if (lastSearchResultsViewedKey === key) {
    return;
  }
  lastSearchResultsViewedKey = key;
  trackExploreJourneyEvent(EVENT_TRACKING.SEARCH_RESULTS_VIEWED, {
    lifecycle_stage: "viewed",
    entry_point: "global_search",
    ...properties,
  });
};

/** Test helper — reset visit scope between cases. */
export const resetSearchResultsViewedVisitScope = () => {
  lastSearchResultsViewedKey = undefined;
};
